<template>
  <div class="container-fluid">
    <vue-title
      :title="'Tospaa Code Challenge - Multiplayer Coding Game / Lounge'"
    ></vue-title>
    <div id="header" class="row justify-content-center">
      <div
        class="col-8 d-flex justify-content-center"
        style="position: relative"
      >
        <img id="header-challenge-logo" src="@/assets/images/game_logo.png" />
      </div>
    </div>

    <div class="row">
      <div
        id="room-container-top"
        class="col-12 container-fluid d-flex flex-wrap"
      >
        <div
          class="room-cell text-center new-game-room-cell"
          style="position: relative; cursor: pointer"
        >
          <div class="challengeTitle">
            New Algorithm Challenge
            <p class="challengeTitleAlt">
              Build the most shortest algorithm by using loop and condition
              blocks<br /><br />
            </p>
          </div>
          <div class="challengeDetails">
            <img
              style="width: 60%; margin-top: -20px"
              src="@/assets/images/icon-challenge.png"
            />
          </div>
          <div class="bd-highlight text-center beginButton">
            <button
              style="width: 100%"
              class="btn btn-info tospaaOrange"
              v-on:click="createNewCodeChallengeRoom"
            >
              Play
            </button>
          </div>
        </div>

        <div
          class="room-cell text-center new-game-room-cell"
          style="position: relative; cursor: pointer"
        >
          <div class="challengeTitle">
            New Result Challenge
            <p class="challengeTitleAlt">
              Read code blocks and pick the final location of tospaa before your
              opponent<br /><br />
            </p>
          </div>
          <div class="challengeDetails">
            <img
              style="width: 60%; margin-top: -20px"
              src="@/assets/images/icon-target.png"
            />
          </div>
          <div class="bd-highlight text-center beginButton">
            <button
              style="width: 100%"
              class="btn btn-info tospaaOrange"
              v-on:click="createNewWhereIsTheTargetRoom"
            >
              Play
            </button>
          </div>
        </div>
      </div>

      <div
        class="col-12 text-center lounge-navigation p-2"
        style="margin-top: 24px"
      >
        <p style="font-size: 28px; font-weight: bold; line-height: 24px">
          Challenges<br /><span style="font-size: 18px"
            >{{ dailyChallengesCount }} challenges in last 24 hours!</span
          >
        </p>
      </div>

      <div
        id="room-container"
        class="col-12 p-2 container-fluid d-flex flex-wrap"
      >
        <div
          v-for="room in roomList"
          :key="room.id"
          class="room-cell-others text-center"
          v-bind:class="
            room.isFull !== 'full' && room.isStarted !== 'started'
              ? 'empty-room-cell'
              : 'full-room-cell'
          "
        >
          <div
            style="
              width: 94%;
              white-space: nowrap;
              overflow: hidden;
              margin: 5px auto;
              font-style: oblique;
              font-size: xx-small;
            "
          >
            {{ room.roomType }}
          </div>
          <div
            v-for="(player, i) in room.playerList"
            :key="i"
            style="width: 100%"
          >
            <div style="width: 100%">
              <country-flag v-bind:country="player.country" />
            </div>
            <div
              style="
                width: 94%;
                white-space: nowrap;
                overflow: hidden;
                margin: 0 auto;
              "
            >
              {{ player.name }}
            </div>
          </div>
          <div
            style="text-align: center; width: 100%"
            v-show="room.isFull !== 'full' && room.isStarted !== 'started'"
            class="btn blinkAnimation"
            v-on:click="joinRoom(room.id, false)"
            v-tooltip="'click to join the game'"
          >
            Waiting for opponent
          </div>
          <div
            v-show="
              room.isFull == 'full' &&
              room.isStarted == 'started' &&
              room.isWatchable == 'watchable'
            "
            class="watchIcon"
            v-tooltip="'click to watch the game'"
            v-on:click="joinRoom(room.id, true)"
          >
            <img
              style="width: 80%; margin-top: -4px"
              src="@/assets/images/icon-watch.png"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      class="p-1 m-3 text-center lounge-navigation"
      style="padding-bottom: 0 !important; margin-top: 34px !important"
    >
      <p style="font-size: 28px; font-weight: bold; line-height: 24px">
        Players<br /><span style="font-size: 18px"
          >{{ playerList.length }} online players</span
        >
      </p>
    </div>

    <div class="row p-1 m-1">
      <div
        id="online-player-container"
        class="col-12 p-2 container-fluid d-flex flex-wrap"
      >
        <div
          v-for="(player, i) in playerList"
          :key="i"
          class="
            online-player-cell
            m-1
            d-flex
            justify-content-center
            text-center
          "
          v-bind:class="
            player.place === 'GAME'
              ? 'online-player-in-room'
              : 'online-player-in-lounge'
          "
        >
          <div style="width: 100%">
            <country-flag v-bind:country="player.country" />
          </div>
          <div
            style="
              width: 94%;
              white-space: nowrap;
              overflow: hidden;
              margin: 0 auto;
            "
          >
            {{ player.name }}
          </div>
        </div>
      </div>
    </div>

    <div>
      <audio loop autoplay id="audio">
        <source src="@/assets/sounds/lounge.wav" type="audio/wav" />
      </audio>
    </div>

    <div style="height: 100px"></div>
  </div>
</template>

<style lang="scss">
@import "../assets/styles/lounge.css";
</style>

<script>
export default {
  data() {
    return {
      userName: "",
      roomList: [],
      playerList: [],
      isClickedAnyRoom: false,
      dailyChallengesCount: 0,

      pingTimer: null,
    };
  },

  computed: {
    isConnected() {
      return this.$store.state.socket.isConnected;
    },
  },

  watch: {
    isConnected() {
      if (!this.isConnected) {
        this.logout();
      }
    },
  },

  mounted: function () {
    //new Audio(require('@/assets/sounds/lounge.wav')).play();

    this.isClickedAnyRoom = false;
    if (!this.security()) {
      console.error("Login to lounge failed");
    } else {
      let obj = {};
      obj.event = "changePlace";
      obj.place = "lounge";
      this.$socket.sendObj(obj);
    }

    let pingDuration = 1000 * 90;
    this.pingTimer = setInterval(() => {
      let obj = {};
      obj.event = "ping";
      this.$socket.sendObj(obj);
    }, pingDuration);
  },

  created() {
    this.$options.sockets.onmessage = (data) => this.messageReceived(data);
  },

  methods: {
    logout: function () {
      this.$socket.close();
      this.$router.push({
        name: "login",
        params: {
          userName: "",
        },
      });
    },

    security: function () {
      this.userName = this.$route.params.userName;
      if (this.userName === "" || this.userName === undefined) {
        this.logout();
        return false;
      }
      return true;
    },

    createNewCodeChallengeRoom: function () {
      if (!this.isClickedAnyRoom) {
        let obj = {};
        obj.event = "newCodeChallengeRoom";
        this.$socket.sendObj(obj);
        this.isClickedAnyRoom = true;
      }
    },

    createNewWhereIsTheTargetRoom: function () {
      if (!this.isClickedAnyRoom) {
        let obj = {};
        obj.event = "newWhereIsTheTargetRoom";
        this.$socket.sendObj(obj);
        this.isClickedAnyRoom = true;
      }
    },

    joinRoom: function (roomId, isWatching) {
      if (!this.isClickedAnyRoom) {
        let obj = {};
        obj.event = "joinRoom";
        obj.id = roomId;
        obj.isWatching = isWatching;
        this.$socket.sendObj(obj);
        this.isClickedAnyRoom = true;
      }
    },

    messageReceived: function (raw_message) {
      let receivedData = JSON.parse(raw_message["data"]);
      if (!Object.prototype.hasOwnProperty.call(receivedData, "event")) {
        console.error("event not found");
        return;
      }

      let event = receivedData["event"];
      switch (event) {
        case "roomList": {
          if (!Object.prototype.hasOwnProperty.call(receivedData, "roomList")) {
            console.error("roomList not found");
            return;
          }
          this.roomList = receivedData["roomList"];
          break;
        }
        case "playerList": {
          if (
            !Object.prototype.hasOwnProperty.call(receivedData, "playerList")
          ) {
            console.error("playerList not found");
            return;
          }
          this.playerList = receivedData["playerList"];
          break;
        }
        case "joinRoom": {
          if (!Object.prototype.hasOwnProperty.call(receivedData, "status")) {
            console.error("status not found");
            return;
          }
          let status = receivedData["status"];
          if (status !== "pass") {
            console.error("join room failed");
            this.isClickedAnyRoom = false;
            return;
          }
          if (!Object.prototype.hasOwnProperty.call(receivedData, "roomType")) {
            console.error("roomType not found");
            return;
          }
          let watchMode = false;
          if (Object.prototype.hasOwnProperty.call(receivedData, "watchMode")) {
            watchMode = receivedData["watchMode"];
          }
          let roomType = receivedData["roomType"];
          switch (roomType) {
            case "CODE_CHALLENGE": {
              this.$router.push({
                name: "game-code-challenge",
                params: {
                  userName: this.userName,
                  isWatching: watchMode,
                },
              });
              break;
            }
            case "WHERE_IS_THE_TARGET": {
              this.$router.push({
                name: "game-where-is-the-target",
                params: {
                  userName: this.userName,
                  isWatching: watchMode,
                },
              });
              break;
            }
            default:
          }
          break;
        }
        case "dailyChallengesCount": {
          if (!Object.prototype.hasOwnProperty.call(receivedData, "count")) {
            console.error("count not found");
            return;
          }
          this.dailyChallengesCount = receivedData["count"];
          break;
        }
      }
    },
  },
};
</script>
